module.exports = __webpack_public_path__ + "static/media/home1.5cf05bba.jpg";